// extracted by mini-css-extract-plugin
module.exports = {"TrashButton":"TrashButton_TrashButton__3SEvm","text":"TrashButton_text__1pInj"};